// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UserMarker_wrapper__1GJqe","marker":"UserMarker_marker__1Bvjv","marker_hover":"UserMarker_marker_hover__3UcB0 UserMarker_marker__1Bvjv"};